import React from "react";
import { withRouter } from "react-router-dom";
import OtpVerifyForm from '../components/sections/OtpVerifyForm';
import { TokenService } from '../api/tokenService';

class OtpVerfy extends React.Component {
    componentDidMount() {
        let token = null;

        if (TokenService && typeof TokenService.getLocalAccessToken === 'function') {
            token = TokenService.getLocalAccessToken();
        } else {
            token = localStorage.getItem('accessToken'); // fallback
        }

        if (token) {
            // already logged in → go to dashboard
            this.props.history.replace('/');
        }
    }

    render() {
        return (
            <OtpVerifyForm className="illustration-section-01" />
        );
    }
}

export default withRouter(OtpVerfy);
